export enum ProviderType {
  LOCAL = "LOCAL",
  GOOGLE = "GOOGLE",
  LINKEDIN = "LINKEDIN"
}

export enum ProviderTextType {
  LOCAL = "Local",
  GOOGLE = "Google",
  LINKEDIN = "LinkedIn"
}